export default __webpack_public_path__ + "static/media/home_sleep_test_image.f5b18187.jpg";